import { inject, Injectable } from '@angular/core';
import { catchError, map } from 'rxjs';
import { handleError } from '../tools/handle-error.tools';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@/environments/environment';
import { ClasificacionHallazgo } from '@/app/models/interface/clasificacion-hallazgo.model';
import {
  PaginatorModel,
  HasPagination,
} from '@/app/models/interface/paginator.model';
import { CustomResponse } from '@/app/models/interface/response.model';

@Injectable({ providedIn: 'root' })
export class ClasificacionHallazgoService {
  private readonly http = inject(HttpClient);
  private readonly url = environment.api + 'clasificacion-hallazgo/';

  create(data: Partial<ClasificacionHallazgo>) {
    return this.http
      .post<CustomResponse<ClasificacionHallazgo>>(this.url, data)
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return {
            ...d,
          };
        }),
      );
  }

  findAll(params?: HttpParams) {
    return this.http
      .get<
        CustomResponse<PaginatorModel<ClasificacionHallazgo[], HasPagination>>
      >(this.url, {
        params,
      })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          if (d && Array.isArray(d.data)) {
            return {
              ...d,
              data: d.data.map((d) => ({
                ...d,
              })),
            };
          }
          return d;
        }),
      );
  }

  findOne(id: number) {
    const url = this.url + id;
    return this.http.get<CustomResponse<ClasificacionHallazgo>>(url).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  update(tipo: Partial<ClasificacionHallazgo>) {
    const url = this.url + tipo.id;
    return this.http.put<CustomResponse<ClasificacionHallazgo>>(url, tipo).pipe(
      catchError((err) => handleError(err)),
      map((data) => {
        const d = data.result;
        return {
          ...d,
        };
      }),
    );
  }

  changeState(state: boolean, id: number) {
    const url = this.url + id;
    return this.http
      .patch<CustomResponse<ClasificacionHallazgo>>(url, { state })
      .pipe(
        catchError((err) => handleError(err)),
        map((data) => {
          const d = data.result;
          return {
            ...d,
          };
        }),
      );
  }
}
